/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiProjectstatusesIdQueryResponse,
  GetApiProjectstatusesIdPathParams,
} from '../models/GetApiProjectstatusesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiProjectstatusesIdQueryResponseSchema } from '../zod/getApiProjectstatusesIdSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiProjectstatusesIdQueryKey = (
  id: GetApiProjectstatusesIdPathParams['id'],
) => [{ url: '/api/projectstatuses/:id', params: { id: id } }] as const;

export type GetApiProjectstatusesIdQueryKey = ReturnType<
  typeof getApiProjectstatusesIdQueryKey
>;

/**
 * {@link /api/projectstatuses/:id}
 */
export async function getApiProjectstatusesId(
  id: GetApiProjectstatusesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectstatusesIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/projectstatuses/${id}`,
    ...requestConfig,
  });
  return getApiProjectstatusesIdQueryResponseSchema.parse(res.data);
}

export function getApiProjectstatusesIdQueryOptions(
  id: GetApiProjectstatusesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectstatusesIdQueryKey(id);
  return queryOptions<
    GetApiProjectstatusesIdQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiProjectstatusesIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectstatusesId(id, config);
    },
  });
}

/**
 * {@link /api/projectstatuses/:id}
 */
export function useGetApiProjectstatusesId<
  TData = GetApiProjectstatusesIdQueryResponse,
  TQueryData = GetApiProjectstatusesIdQueryResponse,
  TQueryKey extends QueryKey = GetApiProjectstatusesIdQueryKey,
>(
  id: GetApiProjectstatusesIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectstatusesIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiProjectstatusesIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiProjectstatusesIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
